import React from 'react';
import PropTypes from 'prop-types';

function BreadcrumbLink({ text, onClick, className }) {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) onClick();
  };

  return (
    <span
      className={className}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      {text}
    </span>
  );
}

BreadcrumbLink.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired
};

export default BreadcrumbLink;
